(() => {
  function initialize(root = document) {
    root.querySelectorAll('.mh-native-nav__item').forEach((item) => {
      if (item.dataset.hoverReady) return;
      item.dataset.hoverReady = 'true';
      const details = item.querySelector('details');
      const summary = details.querySelector('summary');
      let timer;
      const close = () => {
        details.open = false;
        summary.setAttribute('aria-expanded', 'false');
      };
      item.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse' || !matchMedia('(min-width: 990px) and (hover: hover)').matches) return;
        clearTimeout(timer);
        item.closest('nav').querySelectorAll('details[open]').forEach((other) => {
          if (other !== details) {
            other.open = false;
            other.querySelector('summary').setAttribute('aria-expanded', 'false');
          }
        });
        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
      });
      item.addEventListener('pointerleave', () => {
        timer = setTimeout(() => {
          if (!item.contains(document.activeElement)) close();
        }, 160);
      });
      item.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.open) {
          close();
          summary.focus();
          event.stopPropagation();
        }
      });
      details.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(details.open)));
      document.addEventListener('click', (event) => {
        if (!item.contains(event.target)) close();
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
